import React, { useEffect } from "react";

import OMIGPayouts from "./OMIGPayouts";
import OMIGScreenWrapper from "../OMIGScreenWrapper";
import OMIGRewardsSummary from "./OMIGRewardsSummary";
import analyticsService from "../../../lib/AnalyticsService";

const OMIGReward = ({ customer: propCustomer }) => {
  useEffect(() => {
    analyticsService.trackPageView("omig_rewards_summary", {});
  }, []);

  return (
    <OMIGScreenWrapper>
      <div className="max-w-3xl mx-auto space-y-6">
        <OMIGRewardsSummary />
        <OMIGPayouts />
      </div>
    </OMIGScreenWrapper>
  );
};

export default OMIGReward;
